module.exports = __webpack_public_path__ + "static/media/speaker_body_tap.37212022.png";